import { render } from "./BranchesView.vue?vue&type=template&id=d98038f0"
import script from "./BranchesView.vue?vue&type=script&lang=js"
export * from "./BranchesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__